/**
 * @file  routes/index.ts
 * @description  router component which defines the application level routes and mapping/loading of the component that should handle the rendering
 *
 * @author ogarcia (ozkary)
 *
 */
import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';

import routes from './config';

/**
 * router management component to manage the application level routes
 *
 */
const Router = (): JSX.Element => {
  return (
    <Switch>
      {routes.map((routeItem) => {
        return (
          <Route
            key={routeItem.component}
            path={routeItem.path}
            exact={routeItem.exact}
            component={lazy(
              () => import(`../containers/${routeItem.component}`)
            )}
          />
        );
      })}
    </Switch>
  );
};

export default Router;
